"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-plugins/lib/constants");

var _draftExtend = require("draft-extend");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var BLOCK_TYPE = 'atomic';
var DISPLAY_NAME = 'ClipPlugin';

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var Clip = options.Clip;

  var blockRendererFn = function blockRendererFn(_ref) {
    var props = _ref.props;
    return function (currentBlock) {
      if (!(0, _draftHelpers.isCorrectBlockTypeAndSize)(currentBlock, BLOCK_TYPE)) {
        return undefined;
      }

      var entity = (0, _draftHelpers.getDefaultEntity)(currentBlock, props.getEditorState().getCurrentContent().getEntity);

      if (!entity) {
        return undefined;
      }

      var type = entity.getType();

      if (type === _constants.ENTITY_TYPES.clip) {
        return {
          component: Clip,
          editable: false,
          props: Object.assign({}, props, {
            entity: entity
          })
        };
      }

      return undefined;
    };
  };

  var entityToHTML = function entityToHTML(entity, originalText) {
    if (entity.type === _constants.ENTITY_TYPES.clip) {
      var _entity$data = entity.data,
          attribution = _entity$data.attribution,
          name = _entity$data.name,
          src = _entity$data.src,
          type = _entity$data.type,
          quote = _entity$data.quote;
      var renderedAttribution = "<span>" + attribution + "</span>";

      switch (type) {
        case _constants.CLIP_TYPES.QUOTE:
          return "<blockquote><div>" + quote + "</div></blockquote>" + renderedAttribution;

        case _constants.CLIP_TYPES.IMAGE:
          return "<img src=\"" + src + "\" alt=\"" + (name || attribution) + "\" />" + renderedAttribution;

        default:
      }
    }

    return originalText;
  };

  return (0, _draftExtend.createPlugin)({
    blockRendererFn: blockRendererFn(options),
    displayName: DISPLAY_NAME,
    entityToHTML: entityToHTML
  });
};

exports.default = _default;
module.exports = exports.default;